import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function formatSubmittedDate(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}, ${hours}:${minutes}`;
}

export default function QueryDetails() {
  const navigate = useNavigate();
  const complaintSummary = useSelector((store) => store.status?.complaintSummary ?? null);
  const totalCount = complaintSummary?.totalComplaints ?? 0;
  const totalQueries = complaintSummary?.totalComplaints ?? 0;
  const lastQuerySubmittedDate = formatSubmittedDate(complaintSummary?.lastSubmittedAt);

  return (
    <section className="ca-query-details" aria-labelledby="query-management-title">
      <div className="ca-query-details__heading">
        <div className="ca-query-details__title-row">
          <button
            type="button"
            className="ca-settings-page__back"
            onClick={() => navigate('/')}
            aria-label="Back to Complaint Management"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M15 6l-6 6 6 6"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <h1 id="query-management-title" className="ca-query-details__title">
            Complaint Management
          </h1>
        </div>
        <span className="ca-query-details__count">Total Count: {totalCount ?? 0}</span>
      </div>

      <div className="ca-query-details__summary">
        <div className="ca-query-details__card">
          <span className="ca-query-details__label">Total Queries</span>
          <strong className="ca-query-details__value">{totalQueries ?? 0}</strong>
        </div>
        <div className="ca-query-details__card">
          <span className="ca-query-details__label">Last Query Submitted Date</span>
          <strong className="ca-query-details__value">{lastQuerySubmittedDate || '—'}</strong>
        </div>
      </div>
    </section>
  );
}
